import {Component, Input, OnInit} from '@angular/core';
import {take} from "rxjs/operators";
import {FileService} from "../../providers/file.service";
import {ModalController} from "@ionic/angular";
import {AppStateService} from "../../providers/app-state.service";
import {CommonUtils} from "../../utils/common";

@Component({
  selector: 'app-v-image-drop',
  templateUrl: './v-image-drop.component.html',
  styleUrls: ['./v-image-drop.component.scss'],
})
export class VImageDropComponent implements OnInit {

  @Input() vClientUUID: string;
  @Input() vetClinicUUID: string;
  @Input() imageFolder: string;
  @Input() addUUIDToImageFolder: boolean = false;

  multiple: boolean = false;
  accept: string = 'image/jpeg,image/jpg,image/png';
  isBusy: boolean;

  constructor(
    private fileService: FileService,
    private modalController: ModalController,
    private appStateService: AppStateService,
    public commonUtils : CommonUtils
  ) {
  }

  ngOnInit() {
    this.appStateService.isBusySubject.subscribe(e => {
      this.isBusy = e;
    })
  }

  onDrop(event) {
    if (event && event.addedFiles) {
      this.appStateService.updateIsBusySubject(true);
      event.addedFiles.forEach(file => {
        this.fileService.uploadFileToCdn(this.vClientUUID, this.vetClinicUUID, this.imageFolder, file).pipe(take(1)).subscribe(uploadedVImage => {
          this.appStateService.updateIsBusySubject(false);
          this.modalController.dismiss(uploadedVImage).then(() => {
          });
        }, error => {
          this.appStateService.updateIsBusySubject(false);
        })
      })
    }
  }

  progress(event: ProgressEvent) {
    console.log(event)
  }

  onClose() {
    if (!this.isBusy) {
      this.modalController.dismiss(null).then(() => {
      });
    }
  }
}
